const fr = {
  topbar: {
    title: 'Seamless By Save Your Wardrobe',
    logout: 'Se déconnecter'
  },
  common: {
    email: 'E-mail',
    submit: 'Soumettre',
    continue: 'Continuer',
    cancel: 'Annuler',
    back: 'Retour',
    next: 'Suivant',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Éditer',
    confirm: 'Confirmer',
    close: 'Fermer',
    search: 'Rechercher',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    noData: 'Aucune donnée disponible',
    notFound: 'Non trouvé',
    'Back to Dashboard': 'Retour au tableau de bord'
  },
  login: {
    clickLoginBtn: 'Cliquez pour vous connecter',
    loginError: 'Échec de la connexion, veuillez réessayer.'
  },
  ResetPasswordForm: {
    wantLoginPage: 'Vous voulez vous connecter ?',
    login: 'Se connecter'
  },
  booking: {
    nextStepBtnLabel: 'Continuer',
    prevStepBtnLabel: 'Retour au tableau de bord'
  },
  uploadImages: {
    title: 'Télécharger des photos',
    subtitle:
      "Vous pouvez ajouter jusqu'à 4 images de votre article, montrant l'article en entier ainsi que la zone d'émission.",
    uplaodButton: 'Appuyez ici pour ajouter une photo',
    maximumNumber: 'Nombre maximum de photos atteint',
    continueButton: 'Continuer',
    cancelButton: 'Annuler',
    editButton: 'Modifier photos'
  },
  landing: {
    'Brands asked, we delivered. Introducing the':
      'Les marques ont demandé, nous avons livré. Présentation du',
    'Aftersales Diagnostic Tool': 'Outil de diagnostic après-vente ',
    'by Save Your Wardrobe.': 'par Save Your Wardrobe.',
    'Click below to receive a personalised aftersales business case for your business':
      'Cliquez ci-dessous pour recevoir une étude de cas après-vente personnalisée pour votre entreprise',
    'Start assessment': "Commencer l'évaluation"
  },
  itemDetails: {
    'What item needs some love?':
      'Quelle est la catégorie de pièce que vous souhaitez faire réparer ?'
  },
  services: {
    'select a service': 'Sélectionnez un service',
    'select the one that best applies':
      'Sélectionnez celui qui s’applique le mieux'
  },
  businessCase: {
    title: "L'étude de cas",
    description:
      'Voir ci-dessous les avantages financiers projetés de la mise en œuvre de votre solution après-vente recommandée. Vous pouvez modifier vos entrées pour voir une simulation en direct de la façon dont les projections changeraient.',
    summary: 'Résumé',
    customerLifetimeValue: 'Valeur à vie du client',
    ROI: 'Retour sur investissement',
    region: 'Région',
    estimatedCosts: 'Coûts estimés',
    estimatedSavings: 'Économies estimées',
    brandInputs: 'Entrées de la marque',
    totalSavings: 'Revenu brut total/Économies'
  },
  solution: {
    buisnessCase: 'Cas de rentabilité',
    solution: 'La solution',
    benefit: 'Bénéficierait de',
    capture: 'Vous pourriez capturer plus de',
    saving: 'en revenus/économies grâce à la mise en œuvre de cette solution'
  },
  loading: {
    finalisingBusinessCase:
      "Veuillez patienter pendant que nous finalisons l'étude de cas de {{brandName}}"
  }
};

export default fr;
